import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PageTitle from '../../components/PageTitle';
import withUser from '../../hoc/withUser';
import Table from '../../components/Table';
import { getColumnsForUserActivitiesTable } from './userActivitiesColumns';
import { useStore } from '../../store';
import TableContainer from '../../components/TableContainer';
import { mapUserActivities } from './utils/mapUserActivities';

const UserActivitiesPage = observer(({ user, authToken }) => {
  const {
    rootStore: {
      profileStore,
      profileStore: { userActivitiesStore },
    },
  } = useStore();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    userActivitiesStore.loadingUserActivities = true;
    const getUserActivities = async () => {
      if (!profileStore.profileData) {
        await profileStore.initProfile(user, authToken, i18n);
      }

      await userActivitiesStore.getUserActivities(user.sub, { type: '', column: '' });
    };

    getUserActivities().then(() => (userActivitiesStore.loadingUserActivities = false));

    return () => userActivitiesStore.resetUserActivities();
  }, [userActivitiesStore, authToken, i18n, profileStore, user]);

  return (
    <TableContainer>
      <PageTitle titleKey="usersActivitiesPage.title" subtitleKey="usersActivitiesPage.subtitle" />
      <Table
        isTableLoading={userActivitiesStore.loadingUserActivities}
        data={mapUserActivities(userActivitiesStore.userActivities, t) || []}
        columns={getColumnsForUserActivitiesTable(t) || []}
        totalRowsFromDatabase={userActivitiesStore.userActivities.length}
        userId={user.sub}
        onSort={(userId, sort) => userActivitiesStore.getUserActivities(userId, sort)}
        loadTableData={userActivitiesStore.getUserActivities}
      />
    </TableContainer>
  );
});

export default withUser(UserActivitiesPage);
